import { FileWithPath } from "@mantine/dropzone";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useCompany } from "#modules/company/view/useCompany";
import { fileTypeValidator } from "#shared/helpers/dropZoneValidator";
import { getDefaultPartTypeToSearchFor } from "#shared/helpers/getDefaultPartTypeToSearchFor";
import { Dropzone } from "#shared/view/components/Dropzone";
import { Paper } from "#shared/view/components/Paper";
import { ProgressBar } from "#shared/view/components/ProgressBar";
import { Space } from "#shared/view/components/Space";
import { Stack } from "#shared/view/components/Stack";
import { Text } from "#shared/view/components/Text";
import { TitleWithIcon } from "#shared/view/components/TitleWithIcon";
import { getAccept, PartTypeType, UPLOAD_CONFIG } from "shared";

type Props = {
  title?: string;
  isLoading: boolean;
  progress: number;
  uploadFile: (files: FileWithPath[], type: PartTypeType) => Promise<void>;
};

export const SimilarPartDropzoneSection = ({ title, isLoading, progress, uploadFile }: Props) => {
  const { t } = useTranslation();

  const { company } = useCompany();
  const type = useMemo(() => getDefaultPartTypeToSearchFor(company), [company]);

  return (
    <Stack justify="center" align="center">
      <Paper shadow="lg" p="md" miw={400}>
        {title && (
          <>
            <TitleWithIcon title={title} iconName="shapeTriangle" />
            <Space h="xs" />
          </>
        )}
        <Space h="xs" />
        {!!type && (
          <Dropzone
            title={t("similarPart.dropzone.dragStep")}
            subTitle=""
            onDrop={async (files) => {
              await uploadFile(files, type);
            }}
            validator={(files: File) => fileTypeValidator(files, [], [""])}
            loading={isLoading}
            maxSize={UPLOAD_CONFIG.PART.maxFileSize}
            accept={getAccept(UPLOAD_CONFIG.PART.extensions)}
          />
        )}
        <Space h="xs" />
        {progress > 0 && (
          <>
            <Text>Chargement du fichier...</Text>
            <ProgressBar value={progress} label={`${progress} %`} animated={progress < 100} />
          </>
        )}
      </Paper>
    </Stack>
  );
};
